// extracted by mini-css-extract-plugin
module.exports = {"backToResults":"styles_backToResults__VHTy1 system_textBodyL__1KI88"};